export default {
    environment: 'qa',
    appHostname: 'practitioner.luminalearning-qa.com',
    ssoV1Hostname: 'sso.luminalearning-qa.com',
    ssoV2Hostname: 'sso.v2.luminalearning-qa.com',
    financeHostname: 'finance.luminalearning-qa.com',
    graphqlGatewayHostname: 'graphql.api.luminalearning-qa.com',
    luminaOnlineHostname: 'www.luminalearning-qa.com',
    luminaOpenBadgesClientHostname: 'badges.luminalearning-qa.com',
    luminaGetQualifiedUrlHostname: 'luminalearning.com/become-a-practitioner/',
    teamsHostname: 'team.luminalearning-qa.com',
    AtsHostname: 'applicant-tracker.luminalearning-qa.com',
    eLearningHostname: 'e-learning.luminalearning-qa.com',
    openApiHostname: 'api2.luminalearning-qa.com',
    participantProjectPaginationLimit: 10,
    projectAndSearchPaginationLimit: 20,
    availableLocales: [
        'en-GB',
        'cs-CZ',
        'fr-FR',
        'ja-JP',
        'lv-LV',
        'pt-PT',
        'sk-SK',
        'zh-CN',
        'zh-TW',
        'da-DK',
        'pl-PL',
        'id-ID',
        'en-CA',
        'nl-NL',
        'hu-HU',
    ],
};
